import { render, staticRenderFns } from "./select-svg.vue?vue&type=template&id=0e9e82f2&"
import script from "./select-svg.vue?vue&type=script&lang=js&"
export * from "./select-svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9e82f2')) {
      api.createRecord('0e9e82f2', component.options)
    } else {
      api.reload('0e9e82f2', component.options)
    }
    module.hot.accept("./select-svg.vue?vue&type=template&id=0e9e82f2&", function () {
      api.rerender('0e9e82f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/icon/select-svg.vue"
export default component.exports